import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Container from '@/containers';

// 模块路由

import newsRouter from './modules/news'; // 融科堂
import videoRouter from './modules/video'; // 科创微视
import meetingRouter from './modules/meeting'; // 创客坛
import snsRouter from './modules/sns'; // 科创号
import mallRouter from './modules/mall'; //  科技汇
import ucenterRouter from './modules/ucenter'; // 个人中心
import aboutRouter from './modules/about'; // 关于\隐私政策
import loginRouter from './modules/login';


export const constantRoutes = [
    {
        path: '/',
        component: Container,
        redirect: '/index',
        children: [
        {
                path: 'index',
                component: () => import('@/views/dashboard/index'),
                name: 'index',
                meta: {
                    title: '首页',
                    showAddBtn:true
                }
        }
        ]
    },
    loginRouter,
    newsRouter,
    videoRouter,
    meetingRouter,
    snsRouter,
    ucenterRouter,
    mallRouter,
    aboutRouter
];

export const asyncRoutes = [];

const createRouter = () => new VueRouter({
    mode: 'history', // require service support
    routes: constantRoutes
});

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
